import graphql from "babel-plugin-relay/macro";

const updateMutation = graphql`
  mutation updateMutation(
    $id: ID!
    $serves: String
    $name: String!
    $difficulty: DifficultyEnum
    $category: ID
    $hotKeep: Boolean
    $description: String
  ) {
    recipeUpdate(
      input: {
        id: $id
        name: $name
        category: $category
        difficulty: $difficulty
        serves: $serves
        hotKeep: $hotKeep
        description: $description
      }
    ) {
      recipe {
        id
        name
        picture
      }
    }
  }
`;

export default updateMutation;
